import(/* webpackMode: "eager", webpackExports: ["KategoriClient"] */ "/home/u650493134/domains/kelolify.com/hbuilds/source/repository/src/components/kategori/KategoriClient.tsx");
